<template>
  <div class="home">
    <!-- Hero Carousel -->
    <section class="home__hero">
      <el-carousel height="4.4rem" :interval="5000" arrow="hover">
        <el-carousel-item
          v-for="(item, index) in arr"
          :key="index"
          :class="'home__slide--' + index"
        >
          <div class="home__slide-inner">
            <div class="home__slide-image">
              <img :src="require(`../assets/img/${item.img}`)" alt="" />
            </div>
            <div class="home__slide-text">
              <p v-for="(iten, inde) in item.text" :key="inde + 'a'">
                {{ iten }}
              </p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="home__hero-wave"></div>
    </section>

    <!-- Core Technology -->
    <section class="home__section">
      <Function title="核心技术" :fnData="textData" isText />
    </section>

    <!-- Honors -->
    <section class="home__section home__honors">
      <h1 class="section-title">荣誉资质</h1>
      <div class="honors-grid">
        <TransitionGroup name="honors-list">
          <div
            v-for="item in showImgData.obj"
            :key="item"
            class="honors-item"
          >
            <el-image
              :src="require(`../assets/img/${item}`)"
              fit="contain"
            ></el-image>
          </div>
        </TransitionGroup>
      </div>
      <div class="honors-toggle">
        <button class="btn-text" @click="moreImgData">{{ btnText }}</button>
      </div>
    </section>

    <!-- Partners -->
    <section class="home__section">
      <Function title="服务客户及合作伙伴" :fnData="fnData" more />
    </section>
  </div>
</template>

<script>
import Function from "@/components/Function.vue";
import { reactive, ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { computed } from "vue";
import data from "./data.json";
export default {
  name: "Home",
  components: {
    Function,
  },
  setup() {
    let showImgData = reactive({
      obj: data.imgData.slice(0, 4),
    });
    const moreImgData = () => {
      showImgData.obj =
        showImgData.obj.length !== data.imgData.length
          ? data.imgData
          : data.imgData.slice(0, 4);
      btnText.value = btnText.value === "更多荣誉" ? "收起⬆" : "更多荣誉";
    };
    const btnText = ref("更多荣誉");

    const state = computed(() => useStore().state.client);
    return {
      arr: data.arr,
      textData: data.textData,
      fnData: data.fnData,
      state,
      showImgData,
      moreImgData,
      btnText,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.home {
  overflow-x: hidden;
}

// === Hero Carousel ===
.home__hero {
  position: relative;
  .el-carousel {
    margin-bottom: 0;
  }
}

.home__slide--0,
.home__slide--1 {
  background: $gradient-hero;
}

.home__slide-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: $container-width;
  height: 100%;
  margin: 0 auto;
  padding: 0 $space-lg;
}

.home__slide-image {
  flex-shrink: 0;
  img {
    height: 3.6rem;
    border-radius: $radius-md;
    box-shadow: $shadow-lg;
  }
}

.home__slide-text {
  max-width: 50%;
  p {
    font-size: $font-size-body;
    line-height: 1.8;
    color: $color-text-light;
    text-indent: 2em;
    opacity: 0;
    animation: fadeSlideUp 0.6s ease forwards;

    &:nth-child(1) {
      animation-delay: 0.2s;
    }
    &:nth-child(2) {
      animation-delay: 0.4s;
    }
    &:nth-child(3) {
      animation-delay: 0.6s;
    }
  }
}

// Decorative wave divider below carousel
.home__hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 0.3rem;
  background: $color-bg-light;
  clip-path: ellipse(55% 100% at 50% 100%);
}

// === Section Common ===
.home__section {
  padding: $space-3xl 0;
  background: $color-bg-light;

  &:nth-child(odd) {
    background: #ffffff;
  }
}

.section-title {
  text-align: center;
  font-size: $font-size-hero-title;
  color: $color-text-primary;
  margin-bottom: $space-xl;
  position: relative;
  padding-bottom: $space-md;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0.6rem;
    height: 3px;
    background: $gradient-accent;
    border-radius: 2px;
  }
}

// === Honors Grid ===
.honors-grid {
  width: $container-width;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: $space-lg;
}

.honors-item {
  width: calc(20% - $space-lg);
  background: $color-bg-card;
  padding: $space-md;
  border-radius: $radius-md;
  box-shadow: $shadow-sm;
  transition: box-shadow $transition-base, transform $transition-base;

  &:hover {
    box-shadow: $shadow-card-hover;
    transform: translateY(-4px);
  }
  .el-image {
    width: 100%;
  }
}

.honors-toggle {
  width: $container-width;
  margin: $space-lg auto 0;
  text-align: center;
}

.btn-text {
  background: none;
  border: 2px solid $color-accent;
  color: $color-accent;
  font-size: $font-size-caption;
  padding: $space-sm $space-lg;
  border-radius: $radius-lg;
  cursor: pointer;
  transition: all $transition-base;

  &:hover {
    background: $color-accent;
    color: #fff;
  }
}

// === TransitionGroup for honors ===
.honors-list-enter-active,
.honors-list-leave-active {
  transition: all 0.4s ease;
}
.honors-list-enter-from {
  opacity: 0;
  transform: scale(0.8);
}
.honors-list-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
.honors-list-move {
  transition: transform 0.4s ease;
}

// === Keyframes ===
@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
